import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError, UserNotFoundError } from 'utils/errors';
import { customFetch } from 'utils/http';
import { createQueryString } from 'services/production/utils/createQueryString';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idClient: number;
};

export const getClientComment = async (
  params: Params
): Promise<null | string> => {
  const fetchURL = getM8PartnerURL(
    `getClientComment?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    if (response.status === 400) {
      const { message } = await response.json();

      if (message === m8ErrorMessageMap.USER_NOT_FOUND) {
        throw new UserNotFoundError();
      }
    }

    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.text();
  }

  return null;
};
